/**
 * Component mounted method
 * @param {*} component
 * @param {*} FavoritesService
 * @param {*} ProfileService
 */
let mounted = (component,FavoritesService,ProfileService)=>{
    let self = component;
    self.processing = true;
    FavoritesService.getFavorites()
        .then(favorites => {
            if (favorites.length === 0) {
                self.noResults = true;
            } else {
                favorites.map(function (obj) {
                    self.items.push({ sku: obj.sku });
                });
            }
        })
        .catch();
    component.processing = false;
    setTimeout(component.processing, 1000);
}
/**
 *
 * @param {*} component
 * @param {*} profileUtils
 * @param {*} item
 */
let handleFavoriteClick = (component,profileUtils,item)=>{
    if (!item.isFavorite) {
        component.showTrigger = !component.showTrigger;
        component.toastMessage = component.txc.removed_from_favorites;
        component.toastType = 'success';
        profileUtils.publishAnalytics(
            component.$analytics.category.favorites,
            `product: ${item.sku}`,
            'removed_as_favorite'
        );
    } else {
        component.showTrigger = !component.showTrigger;
        component.toastMessage = component.txc.added_to_favorites;
        component.toastType = 'success';
        profileUtils.publishAnalytics(
            component.$analytics.category.favorites,
            `product: ${item.sku}`,
            'added_as_favorite'
        );
    }
}
/**
 *
 * @param {*} component
 * @param {*} profileUtils
 * @param {*} item
 */
let handleAddedToCart = (component,profileUtils,item)=>{
    profileUtils.publishAnalytics(
        component.$analytics.category.favorites,
        `product: ${item.sku}`,
        'added_to_cart'
    );
}



export default {
    handleFavoriteClick:handleFavoriteClick,
    handleAddedToCart:handleAddedToCart,
    mounted:mounted
};
